import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type URL as SchemaURL } from '../schemas/URL';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GenerateYandexPayWidgetURLContentType = '' as const;
export type GenerateYandexPayWidgetURLRequest = undefined;
export type GenerateYandexPayWidgetURLResponses = LinkCommonErrorResponses & {
    /**
     * @description Order ready for pay
     */
    '200': {
        'application/json': SchemaURL;
    };
};
export type GenerateYandexPayWidgetURLResponseSuccess = GenerateYandexPayWidgetURLResponses['200']['application/json'];
export type GenerateYandexPayWidgetURLSearchParams = {
    on_error_redirect: string;
    on_success_redirect: string;
    on_abort_redirect: string;
    signature: string;
    initial_payment_options: string;
};
export type GenerateYandexPayWidgetURLPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GenerateYandexPayWidgetURLUrl = '/{store_slug}/orders/{order_id}/yandexpay/widget/url' as const;
export const GenerateYandexPayWidgetURLMethod = 'GET' as const;
export const getGenerateYandexPayWidgetURLUrl = (params: GenerateYandexPayWidgetURLPathParameters) =>
    GenerateYandexPayWidgetURLUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GenerateYandexPayWidgetURLPathParameters) => String(params[param])
    );
